import { useState } from 'react'

export const PASSCODE_TOKEN_KEY = 'lens_passcode_token'

export function getPasscodeToken(): string | null {
  return localStorage.getItem(PASSCODE_TOKEN_KEY)
}

interface PasscodeScreenProps {
  onSuccess: () => void
}

export function PasscodeScreen({ onSuccess }: PasscodeScreenProps) {
  const [passcode, setPasscode] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      const res = await fetch('/api/v1/auth/passcode', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ passcode }),
      })
      if (!res.ok) {
        setError('Invalid passcode. Please try again.')
        setLoading(false)
        return
      }
      const data = await res.json()
      // Store ONLY the issued session token, never the raw passcode.
      localStorage.setItem(PASSCODE_TOKEN_KEY, data.access_token)
      onSuccess()
    } catch {
      setError('Something went wrong. Please try again.')
      setLoading(false)
    }
  }

  return (
    <div className="passcode-screen">
      <form onSubmit={submit} className="passcode-form">
        <h1>Lens Demo</h1>
        <label htmlFor="passcode">Passcode</label>
        <input
          id="passcode"
          type="password"
          value={passcode}
          onChange={(e) => setPasscode(e.target.value)}
          autoFocus
        />
        <button type="submit" className="btn btn-primary" disabled={loading || !passcode}>
          {loading ? 'Signing in…' : 'Sign in'}
        </button>
        {error && <p className="passcode-error" role="alert">{error}</p>}
      </form>
    </div>
  )
}
